/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as l10n from './virtualservice-scale-in.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @ngdoc component
 * @name  virtualserviceScaleIn
 * @description
 *     Modal for scaling in a VIP. Allows the user to select a VIP and a Service Engine.
 * @param {Function} onCancel - Called when cancelling the scale in process.
 * @param {Function} onComplete - Called after the scale in process has been initiated.
 * @param {VirtualService} virtualservice
 */
class VirtualserviceScaleInController {
    constructor(l10nService) {
        /**
         * Get keys from source bundles for template usage
         */
        this.l10nKeys = l10nKeys;

        l10nService.registerSourceBundles(dictionary);

        this.l10nService_ = l10nService;
    }

    $onInit() {
        this.params = {
            from_se_ref: undefined,
            vip_id: undefined,
        };

        this.vips = this.virtualservice.getIPAddresses('hash');

        const [vip] = this.vips;

        if (vip) {
            this.params.vip_id = vip.vip_id;
        }

        this.setServiceEnginesList();
    }

    /**
     * Sets the list of Service Engines for selection in the dropdown.
     */
    setServiceEnginesList() {
        const { params } = this;

        params.from_se_ref = undefined;

        if (angular.isUndefined(params.vip_id)) {
            this.serviceEngines = [];
        } else {
            const runtime = this.virtualservice.getRuntimeData();
            const vipSummary = _.findWhere(runtime.vip_summary, { vip_id: params.vip_id });

            this.serviceEngines = vipSummary.service_engine;
        }
    }

    /**
     * Makes a request to scale in the selected VIP and SE.
     */
    submit() {
        this.busy = true;
        this.errors = null;

        this.virtualservice.scaleIn(this.params)
            .then(() => this.onComplete({ vipId: this.params.vip_id }))
            .catch(({ data }) => this.errors = data)
            .finally(() => this.busy = false);
    }
}

VirtualserviceScaleInController.$inject = [
    'l10nService',
];

angular.module('aviApp').component('virtualserviceScaleIn', {
    bindings: {
        onCancel: '&',
        onComplete: '&',
        virtualservice: '<',
    },
    controller: VirtualserviceScaleInController,
    templateUrl: 'src/components/applications/virtualservice/virtualservice-scale/' +
            'virtualservice-scale-in/virtualservice-scale-in.html',
});
